<template>
    <div v-if="componentMounted" class="toast-container" v-bind:class="{'visible': visible}">
        <div class="toast">
            <i :class="iconClass" v-show="!!iconClass" />
            <div>
                <div v-if="title" class="title">{{title}}</div>
                <div>{{message}}</div>
            </div>
        </div>
    </div>
</template>

<script src="./mvt-toastcenter.js"></script>

<style lang="scss">
@use "./mvt-toastcenter.scss" as *;
</style>